import type { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../config/authConfig';

const FLAG = 'm365adminbox-teams-auth';

/**
 * Läuft im von Teams geöffneten Auth-Popup (`authentication.authenticate`).
 * Führt die MSAL-Anmeldung als Top-Level-Fenster durch und meldet das Ergebnis
 * via teams-js zurück an den Tab. Gibt true zurück, wenn dieses Fenster das
 * Popup ist (dann darf die normale App NICHT gerendert werden).
 */
export async function handleTeamsAuthPopup(msal: IPublicClientApplication): Promise<boolean> {
  const isStart = new URLSearchParams(window.location.search).has('teamsauth');
  const isReturn = sessionStorage.getItem(FLAG) === '1';
  if (!isStart && !isReturn) {
    return false;
  }

  await msal.initialize();
  const resp = await msal.handleRedirectPromise();

  if (resp) {
    // Zurück von Entra ID → Tab informieren. Der Account liegt nun im
    // localStorage (gleicher Origin), der Tab findet ihn nach Reload.
    sessionStorage.removeItem(FLAG);
    await notifyTeams((auth) => auth.notifySuccess(resp.account?.username ?? 'ok'));
    return true;
  }

  if (isReturn) {
    // Flag gesetzt, aber keine Antwort → Anmeldung abgebrochen/fehlgeschlagen.
    sessionStorage.removeItem(FLAG);
    await notifyTeams((auth) => auth.notifyFailure('login_failed'));
    return true;
  }

  // Erstes Laden des Popups → Anmeldung starten (Rückkehr zur Origin-Wurzel).
  sessionStorage.setItem(FLAG, '1');
  await msal.loginRedirect({ ...loginRequest, redirectStartPage: `${window.location.origin}/` });
  return true;
}

async function notifyTeams(action: (auth: typeof import('@microsoft/teams-js').authentication) => void): Promise<void> {
  try {
    const { app, authentication } = await import('@microsoft/teams-js');
    await app.initialize();
    action(authentication);
  } catch {
    /* außerhalb von Teams nicht relevant */
  }
}
